import React from "react";

// ----------------------------------------------------------------------
// KPI Card (LOCAL – SAME STYLE AS Process Master)
// ----------------------------------------------------------------------
const KpiCard = ({ title, value, color }) => (
  <div
    style={{
      flex: 1,
      background: "#fff",
      borderRadius: 12,
      padding: "12px 16px",
      boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
      borderLeft: `6px solid ${color}`,
    }}
  >
    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>
      {title}
    </div>
    <div style={{ fontSize: 22, fontWeight: 600 }}>
      {value}
    </div>
  </div>
);

// ----------------------------------------------------------------------
// Routing KPI Bar
// ----------------------------------------------------------------------
export default function RoutingKpiBar({ stats }) {
  return (
    <div
      style={{
        display: "flex",
        gap: 16,
        marginBottom: 20,
      }}
    >
      <KpiCard
        title="Total Routings"
        value={stats.total}
        color="#0f766e"
      />
      <KpiCard
        title="Draft"
        value={stats.draft}
        color="#f59e0b"
      />
      <KpiCard
        title="Approved"
        value={stats.approved}
        color="#16a34a"
      />
      <KpiCard
        title="Estimated Cost"
        value={`₹ ${stats.estimatedCost}`}
        color="#2563eb"
      />
    </div>
  );
}
